import script from "./ProposalProgram.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposalProgram.vue?vue&type=script&setup=true&lang=js"

import "./ProposalProgram.vue?vue&type=style&index=0&id=7db17b3f&lang=scss"

const __exports__ = script;

export default __exports__